export const SSO_ERROR_QUERY_PARAM = 'ssoErrorCode';

export const SSO_ERROR_CODES = Object.freeze({
  LOGIN_FAILED: 'SSO_LOGIN_FAILED',
  USER_NOT_FOUND: 'SSO_USER_NOT_FOUND',
});

const SSO_ERROR_MESSAGES = Object.freeze({
  [SSO_ERROR_CODES.LOGIN_FAILED]: Object.freeze({
    id: 'login.sso.error.loginFailed',
    defaultMessage: 'There was a problem signing in.',
  }),
  [SSO_ERROR_CODES.USER_NOT_FOUND]: Object.freeze({
    id: 'login.sso.error.userNotFound',
    defaultMessage: 'User information could not be found in the system.',
  }),
});

const GENERIC_SSO_ERROR_MESSAGE = SSO_ERROR_MESSAGES[SSO_ERROR_CODES.LOGIN_FAILED];

export const getSsoErrorMessage = (search) => {
  const errorCodes = new URLSearchParams(search || '').getAll(SSO_ERROR_QUERY_PARAM);

  if (errorCodes.length === 0) {
    return null;
  }

  if (errorCodes.length !== 1) {
    return GENERIC_SSO_ERROR_MESSAGE;
  }

  const errorCode = errorCodes[0];

  return Object.prototype.hasOwnProperty.call(SSO_ERROR_MESSAGES, errorCode)
    ? SSO_ERROR_MESSAGES[errorCode]
    : GENERIC_SSO_ERROR_MESSAGE;
};

export const removeSsoErrorCodeFromSearch = (search) => {
  const searchParams = new URLSearchParams(search || '');

  searchParams.delete(SSO_ERROR_QUERY_PARAM);

  const sanitizedSearch = searchParams.toString();

  return sanitizedSearch ? `?${sanitizedSearch}` : '';
};
